export const MainCommercialsnowRemoval = {
    "imageUrl": "/assets/imgs/services/6CommercialsnowRemoval/fondo.png",
    "eyebrow": "Commercial",
    "title": " Snow Removal",
    "headingSpan": "KEEP YOUR PROPERTY",
    "heading": "SAFE & ACCESSIBLE",
    "description": "Winter weather can create hazardous conditions for businesses, tenants, and customers. At HRD Painting & Restoration, we provide reliable and efficient snow and ice removal services to keep your property safe, clear, and fully operational throughout the winter months.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};